import React, { useState, useEffect, useRef } from "react";
import axios from 'axios';
import { ReactComponent as ArrowDownIcon } from "../../../assets/svg/arrow-down.svg";
import { ReactComponent as ArrowUpIcon } from "../../../assets/svg/arrow-up.svg";
import { getCookie } from '../../getcookie.js';

    const SearchWithFreeText = ({ onDropdownChange,onChangeSearch, apiUrl, placeholder, selectedValue,selectedOption,params={},searchLimit=0, readOnly, numberOnly }) => {
      const [isOpen, setIsOpen] = useState(false);
      const [searchTerm, setSearchTerm] = useState("");
      const [options, setOptions] = useState([]);
      const [filteredOptions, setFilteredOptions] = useState([]);
     /*  const [selectedOption, setSelectedOption] = useState(null); */
      const [loading, setLoading] = useState(false);
      const [error, setError] = useState(null);
      const dropdownRef = useRef(null);
    
      // Mock API call to fetch options
      const fetchOptions = async () => {
        setLoading(true);
        setError(null);
        try {
          if(apiUrl!==undefined && apiUrl!==""){
            params["term"]=searchTerm;
           await axios.get(apiUrl, {
            params: params??{term:''},
            headers: {
                'Content-Type': 'application/json; charset=UTF-8',
                "Accept": "application/json",
        
                "Access-Control-Allow-Origin": "*", // Required for CORS support to work
                 "Authorization":getCookie("mawalog")
              }
          }).then((response) => {
            if(response.status===200){
                if (response.data.success === true) {
                 
          setOptions(response.data.suggestionlist); 
          setFilteredOptions(response.data.suggestionlist);                 
                }else{
                  setOptions([]); 
                  setFilteredOptions([]);  
                }
            }
          });
    
        
        }
        } catch (err) {
          console.error("Error fetching options:", err);
          setError("Failed to fetch options. Try again.");
        } finally {
          setLoading(false);
        }
      };
      useEffect(() => {
        setSearchTerm(selectedValue);
      }, [selectedValue]);
      // Fetch options when component mounts or search term changes
      useEffect(() => {
        if(searchLimit<=searchTerm?.length || searchLimit===0){
          fetchOptions();
        }        
      }, [searchTerm]);
    
      // Filter options based on search term
      useEffect(() => {
        if (searchTerm === "") {
          setFilteredOptions(options);
        } else {
          if(options.length>0){
          setFilteredOptions(
            options.filter((option) =>
              option.label!=null && option?.label?.toLowerCase().includes(searchTerm?.toLowerCase())
            )
          );
        }
        }
      }, [searchTerm, options]);
    
      // Handle outside click to close the dropdown
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
    
      useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, []);
    
      const toggleDropdown = () =>{
         setIsOpen((prev) => !prev);
         if(!isOpen){
          fetchOptions();
         }
         }
    
      const selectOption = (option) => {
        /* setSelectedOption(option); */
        onDropdownChange(option);
        setIsOpen(false);
      };
    
      return (
        <div ref={dropdownRef} style={{ position: "relative",  height:"40px" }}>
          {/* Dropdown Header */}
          <div
            onClick={toggleDropdown}
            style={{
              height:"40px",
              padding: "10px",
              border: isOpen?"1.4px solid #2C8C53":"1px solid #E5E5E5",
              borderRadius: "8px",
              cursor: "pointer",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              background: "#FFFFFF",
              color:selectedOption || (selectedValue!=="") ?'#1E1E1E':'#81878C'
            }}
          >
            {/* {selectedOption ? selectedOption.label :(selectedValue!=null && selectedValue!=="")?selectedValue: placeholder } */}
            <input
                type="text"
                value={searchTerm}
                onChange={(e) =>{
                  if(numberOnly!=null && numberOnly===true){
                    const value = e.target.value.replace(
                      /\D/g,
                      ""
                    );
                    setSearchTerm(value);onChangeSearch(value)
                  }else{
                    setSearchTerm(e.target.value);onChangeSearch(e.target.value)
                  }
                  }}
                placeholder="Search..."
                readOnly={readOnly!=null?readOnly:false}
                style={{
                  width: "100%",
                  /* padding: "8px", */
                  border: "none",
                  outline:'none',
                  borderBottom: "1px solid #fff",
                  boxSizing: "border-box",
                  color:'#1E1E1E'
                }}
              />
            <span style={{ marginLeft: "10px" }}>{isOpen ? <ArrowUpIcon/> : <ArrowDownIcon/>}</span>
          </div>
    
          {/* Dropdown Options */}
          {isOpen && !readOnly && (
            <div
              style={{
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                border: "1px solid #ccc",
                borderRadius: "4px",
                background: "#fff",
                zIndex: 1000,
                maxHeight: "200px",
                overflowY: "auto",
              }}
            >
              {/* Search Input */}
              {/* <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                placeholder="Search..."
                style={{
                  width: "100%",
                  padding: "8px",
                  border: "none",
                  borderBottom: "1px solid #ccc",
                  boxSizing: "border-box",
                  color:'#1E1E1E'
                }}
              /> */}
    
              {/* Options */}
              {loading ? (
                <div style={{ padding: "10px", textAlign: "center" }}>Loading...</div>
              ) : error ? (
                <div style={{ padding: "10px", textAlign: "center", color: "red" }}>
                  {error}
                </div>
              ) : filteredOptions.length > 0 ? (
                filteredOptions.map((option, index) => (
                  <div
                    key={index}
                    onClick={() => selectOption(option)}
                    style={{
                      padding: "10px",
                      cursor: "pointer",
                      background:
                        selectedOption && selectedOption.id === option.id
                          ? "#f0f0f0"
                          : "#fff",
                          color:'#1E1E1E',
                           textAlign: "left"
                    }}
                  >
                    {option.label}
                  </div>
                ))
              ) : (
                <div style={{ padding: "10px", textAlign: "center" }}>
                  No options found.
                </div>
              )}
            </div>
          )}
        </div>
      );
    };
    
    export default SearchWithFreeText;
  